import user from "./user";
import users from "./users";
import createUser from "./createUser";
import updateUser from "./updateUser";
import searchUsers from "./searchUsers";
import userByToken from "./userByToken";
import changePassword from "./changePassword";

const userReducer = {
  user,
  users,
  createUser,
  updateUser,
  searchUsers,
  userByToken,
  changePassword,
};

export default userReducer;
